module.exports = __webpack_public_path__ + "img/passport-back.2660569b.jpg";